import React from "react";
import ReactDOM from "react-dom/client";
import SettingsPageContainer from "./institution_settings/SettingsPageContainer";

function renderReactElements() {
  const CONTAINERS = {
    "#institution_settings_container": SettingsPageContainer,
  };

  Object.keys(CONTAINERS).forEach((selector) => {
    const containers = document.querySelectorAll(selector);
    containers.forEach((container) => {
      const root = ReactDOM.createRoot(container);
      root.render(React.createElement(CONTAINERS[selector]));
    });
  });
};

document.addEventListener("DOMContentLoaded", renderReactElements);
